<app-institution-card
	*ngIf="
		lender?.mortgageeType === mortgageeTypes.INSTITUTION ||
		lender?.mortgageeType === mortgageeTypes.COMPUTERSHARE
	"
	[finInstitution]="lender"
	[(collapsed)]="collapsed"
	[primary]="primary"
	(collapsedChange)="collapsedChange.emit($event)"
	[collapsable]="collapsable"
	[highlightOnExpand]="highlightOnExpand"
	[hideKebab]="hideKebab"
	[hideBranchSelector]="hideBranchSelector"
	[hideContactDetails]="hideContactDetails"
	(removeInstitution)="onFinancialInstitutionRemove()"
	(editInstitution)="onFinancialInstitutionEdit($event)"
	(setBranch)="onBranchAddedToFinancialInstitution($event)"
	(editBranch)="onBranchAddedToFinancialInstitution($event)"
	(removeBranch)="onBranchRemovedFromFinancialInstitution()"
	(createBranch)="onBranchAddedToFinancialInstitution($event)"
	(onAddAssociation)="onAddAssociation.emit($event)"
	(onRemoveInvestor)="onRemoveInvestor.emit($event)"
	(onSetAsPrimary)="onSetAsPrimary.emit($event)"
></app-institution-card>

<app-client-lender-card
	*ngIf="lender?.mortgageeType === mortgageeTypes.PRIVATE_LENDER && clientData"
	[primary]="primary"
	[(collapsed)]="collapsed"
	(collapsedChange)="collapsedChange.emit($event)"
	[collapsable]="collapsable"
	[hideKebab]="hideKebab"
	[highlightOnExpand]="highlightOnExpand"
	[client]="clientData"
	(onRemoveLenderClient)="onRemoveLenderClient()"
	(onAddAssociatedClient)="onAddAssociation.emit($event)"
	(onSetAsPrimary)="onSetAsPrimary.emit($event)"
>
</app-client-lender-card>
